import { useHistory } from "react-router-dom";
import styles from "./Home.module.scss";
import { _routes } from "../../App";
import { Fragment } from "react/jsx-runtime";

const Home = () => {
    const history = useHistory();
    return <div className={styles.container}>
        {
            _routes.map((route, index) => {
                if (!route.display) return <Fragment key={index}></Fragment>
                return (
                    <button key={index} onClick={() => history.push(route.path)} className={styles['button-container']}>
                        {route.icon && <route.icon className={styles.icon} />}
                        {route.displayName}
                    </button>
                )
            })
        }
    </div>
}

export default Home;